/* eslint-disable react/jsx-max-depth */
/* eslint-disable react/no-multi-comp */
/* eslint-disable react/jsx-newline */
import "./App.scss";
import { QueryClient, QueryClientProvider } from "react-query";
import React, { Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import { AuthProvider } from "./services/wp.auth.service";
import { Container } from "react-bootstrap";
import { ReactQueryDevtools } from "react-query/devtools";
import { createWebStoragePersistor } from "react-query/createWebStoragePersistor-experimental";
import { persistQueryClient } from "react-query/persistQueryClient-experimental";

import { AnnouncementsContextProvider } from "./components/AnnouncementsContext";
import ContentPage from "./components/ContentPage";
import Loader from "./components/Loader";
import { NotifcationsContextProvider } from "./components/NotificationsContext";
import RequireAuth from "./components/RequireAuth";

const PrivacyPolicy = () => <ContentPage pageSlug="privacy-policy" />;
const TermsOfUse = () => <ContentPage pageSlug="terms-of-use" />;

/*
 * These dynamic imports establish code splitting.
 * Webpack will generate one bundle/chunk for each of the
 * staff, practitioner, and respondent sections of the app.
 */
const LoginRoutes = React.lazy(() => import("./pages/login/LoginRoutes" /* webpackChunkName: "login" */));
const TempLanding = React.lazy(() => import("./pages/TempLanding" /* webpackChunkName: "tempLanding" */));
const StaffRoutes = React.lazy(() => import("./pages/staff/StaffRoutes" /* webpackChunkName: "staff" */));
const PractitionerRoutes = React.lazy(() => import("./pages/practitioner/PractitionerRoutes" /* webpackChunkName: "practioner" */));
const RespondentRoutes = React.lazy(() => import("./pages/respondent/RespondentRoutesProvider" /* webpackChunkName: "respondent" */));

const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			cacheTime: 1000 * 60 * 15
		}
	}
});

const useLocalStorage = false;
if (useLocalStorage) {
	const localStoragePersistor = createWebStoragePersistor({ storage: window.localStorage });
	persistQueryClient({
		buster: "Stuff",
		persistor: localStoragePersistor,
		queryClient
	});
}

const App = () => (
	<QueryClientProvider client={queryClient}>
		<AuthProvider>
			<AnnouncementsContextProvider>
				<NotifcationsContextProvider>
					<Container className="App" fluid>
						<Suspense
							fallback={<Loader />}
						>
							<Routes>
								<Route element={<TempLanding />} path="/temp" />
								<Route
									element={
										<RequireAuth requireRole="staff">
											<StaffRoutes />
										</RequireAuth>
									} path="/staff/*"
								/>
								<Route
									element={
										<RequireAuth requireRole="practitioner">
											<PractitionerRoutes />
										</RequireAuth>
									} path="/practitioner/*"
								/>
								<Route
									element={
										<RequireAuth requireRole="respondent">
											<RespondentRoutes />
										</RequireAuth>
									} path="/respondent/*"
								/>
								<Route element={<PrivacyPolicy />} path="privacy-policy" />
								<Route element={<TermsOfUse />} path="terms-of-use" />
								<Route element={<LoginRoutes />} path="/login/*" />
								<Route element={<LoginRoutes />} path="*" />
							</Routes>
						</Suspense>
					</Container>
				</NotifcationsContextProvider>
			</AnnouncementsContextProvider>
		</AuthProvider>
		<ReactQueryDevtools initialIsOpen={false} />
	</QueryClientProvider>
);

export default App;
